export const Assets = {}

function add(type, label, plural, pluralLabel) {
  Assets[type] = { type, label, plural, pluralLabel }
}

add('config', 'Config', 'configs', 'Configs')
add('body', 'Body', 'bodies', 'Bodies')
add('icon', 'Icon', 'icons', 'Icons')
add('texture', 'Texture', 'textures', 'Textures')
add('block', 'Block', 'blocks', 'Blocks')
add('item', 'Item', 'items', 'Items')
add('tool', 'Tool', 'tools', 'Tools')
add('consumable', 'Consumable', 'consumables', 'Consumables')
add('wearable', 'Wearable', 'wearables', 'Wearables')
add('entity', 'Entity', 'entities', 'Entities')
add('script', 'Script', 'scripts', 'Scripts')
add('sound', 'Sound', 'sounds', 'Sounds')
